/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_RatingInputs */

const en_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating`)
};

const fr_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notation`)
};

const de_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung`)
};

const it_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione`)
};

const ru_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг`)
};

const es_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación`)
};

const zh_cn2_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等级`)
};

const ja_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`評価`)
};

const hi_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेटिंग`)
};

const pt_pt2_subtitle_export_vchip_rating = /** @type {(inputs: Subtitle_Export_Vchip_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação`)
};

/**
* | output |
* | --- |
* | "Rating" |
*
* @param {Subtitle_Export_Vchip_RatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_rating = /** @type {((inputs?: Subtitle_Export_Vchip_RatingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_RatingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_rating(inputs)
	if (locale === "de") return de_subtitle_export_vchip_rating(inputs)
	if (locale === "it") return it_subtitle_export_vchip_rating(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_rating(inputs)
	if (locale === "es") return es_subtitle_export_vchip_rating(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_rating(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_rating(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_rating(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_rating(inputs)
	return en_subtitle_export_vchip_rating(inputs)
});